'use client'

import { useAIState, useUIState } from 'ai/rsc'
import { signOut, useSession } from 'next-auth/react'
import { HiOutlinePencilSquare } from 'react-icons/hi2'

export function Logout() {
  const session = useSession()

  const [messagesUIState, setMessagesUIState] = useUIState()
  const [aiState, setAIState] = useAIState()
  if (session.status !== 'authenticated') {
    return null
  }

  return (
    <div className="flex justify-end">
      <button
        className="text-sm whitespace-nowrap rounded-full p-2"
        onClick={() => {
          signOut()
        }}
      >
        Log out
      </button>
    </div>
  )
}
